<!-- BlogEditor.vue -->
<template>
  <div class="space-y-4">
    <label class="block mb-2 text-sm font-medium text-gray-700">
      Conteúdo da Notícia
    </label>

    <EditorToolbar />
  </div>
</template>

<script setup>
import { dataExtinguisher } from '@/modules/extinguisher/store'
import EditorToolbar from './EditorToolbar.vue'
import { ref } from 'vue'

const editor = ref(null)

</script>
